import { WidgetPlainText } from '@thesisedu/feature-widgets-react'
import React from 'react'

import { CommentFragment } from './schema'

export interface CommentPlainTextProps extends Pick<CommentFragment, 'comment' | 'blockComment'> {}
export function CommentPlainText({ comment, blockComment }: CommentPlainTextProps) {
  return blockComment ? <WidgetPlainText value={blockComment} /> : <>{comment}</>
}
